import React from "react";
import WizardContextProvider from "./WizardContextProvider";
import Page from "./Page";
import WelcomePage from "./WelcomePage";
import FinishPage from "./FinishPage";

/**
 * WizardView - Main wrapper component for creating wizards
 * Automatically instantiates WizardContextProvider and adds WelcomePage at the start and FinishPage at the end
 *
 * Props:
 *   - title: Title of the wizard
 *   - inputManifest: Initial/reference data object (optional, defaults to {})
 *   - emittedManifest: Initial emitted data object (optional, defaults to {})
 *   - onClose: Callback when wizard is closed (receives emittedManifest)
 *   - onFinish: Callback when wizard is finished (receives emittedManifest)
 *   - canClose: Whether the close button should be shown (default: true)
 *   - width: Wizard width (default: "1100px")
 *   - height: Wizard height (default: "600px")
 *   - modal: Whether to display as a centered modal (default: false)
 *   - showWelcomePage: Whether to show the automatic welcome page (default: true)
 *   - showFinishPage: Whether to show the automatic finish page (default: true)
 *   - children: WizardView.Page components
 */
const WizardView = (props) => {
    const showWelcomePage = props.showWelcomePage !== false;
    const showFinishPage = props.showFinishPage !== false;

    // Prepare children array
    const userPages = Array.isArray(props.children)
        ? props.children
        : [props.children];

    // Build the final pages array
    let allPages = [...userPages];

    // Add WelcomePage as the first page if showWelcomePage is true
    if (showWelcomePage) {
        allPages = [
            <Page key="welcome-page" title="Welcome" icon="home">
                <WelcomePage />
            </Page>,
            ...allPages,
        ];
    }

    // Add FinishPage as the last page if showFinishPage is true
    if (showFinishPage) {
        allPages = [
            ...allPages,
            <Page key="finish-page" title="Review" icon="check-circle">
                <FinishPage />
            </Page>,
        ];
    }

    return <WizardContextProvider {...props}>{allPages}</WizardContextProvider>;
};

// Attach Page component to WizardView namespace
WizardView.Page = Page;

export default WizardView;
